module.exports = __webpack_public_path__ + "static/media/Icon-4.436df0aa.svg";